import { useMutation } from '@tanstack/react-query';
import { createLoyaltyMutation, extractRewardsStatusByBarcode } from '~/services/loyalty/lib';
import { useErrorHandler } from '~/shared/utils/errorBoundary/hooks/useErrorHandler';
import { useQueryClient } from '@tanstack/react-query';
import { MutationKeys, QueryKeys } from '~/services/loyalty/constants';
import { useTranslation } from '~/shared/utils/translation';
import { PaymentMethod } from '~/shared/constants';
import { Basket } from '~/lib/data-contract/salesforce';

export const useReleaseMemberReward = () => {
    const { translate } = useTranslation();
    const { trackAndDisplayError: trackError } = useErrorHandler();
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: [MutationKeys.RELEASE_REWARD],
        mutationFn: async (paymentInstruments: Basket['paymentInstruments']) => {
            const rewards = extractRewardsStatusByBarcode(
                paymentInstruments,
                PaymentMethod.LOYALTY,
            );

            if (rewards.length === 0) return;

            for (const reward of rewards) {
                try {
                    await createLoyaltyMutation('ReleaseMemberReward', translate, trackError, {
                        memberId: reward.memberAccountNo,
                        rewardCode: reward.barcode,
                    });
                } catch (err) {
                    console.log(err);
                }
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [QueryKeys.ACTIVE_MEMBER_REWARDS],
            });
        },
    });
};
